import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { getProfileService } from 'services/auth';
import {
  ProfileDataType
} from 'services/auth/types';
import {
  removeAccessToken,
  removeRefreshAccessToken
} from 'services/common/storage';

interface AuthState {
  profile?: ProfileDataType;
  isLoading: boolean;
}

const initialState: AuthState = {
  profile: undefined,
  isLoading: false,
};

export const getProfileAction = createAsyncThunk<ProfileDataType>(
  'profileReducer/getProfileService',
  async (_, { rejectWithValue }) => {
    try {
      const res = await getProfileService();
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const authSlice = createSlice({
  name: 'authReducer',
  initialState,
  reducers: {
    resetAuth($state) {
      $state.profile = undefined;
      removeAccessToken();
      removeRefreshAccessToken();
    },
    updateProfile($state, action: PayloadAction<ProfileDataType>) {
      $state.profile = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(getProfileAction.pending, ($state) => {
      $state.isLoading = true;
    });
    builder.addCase(getProfileAction.fulfilled, ($state, action) => {
      $state.profile = action.payload;
      $state.isLoading = false;
    });
    builder.addCase(getProfileAction.rejected, ($state) => {
      $state.isLoading = false;
    });
  },
});

export const { resetAuth, updateProfile } = authSlice.actions;

export default authSlice.reducer;
